import { initSearchForm } from 'src/pages/help/assets/scripts/components/search-form'

initSearchForm()
